<template>
    <div class="ui-control-groups">
        <div
            v-for="group in groups"
            :key="group.value"
            class="ui-control-group"
        >
            <div class="ui-control-group__header">
                <label class="ui-control-group__competition">
                    <input
                        type="checkbox"
                        :checked="pendingTypes.includes(group.value)"
                        :disabled="disabled"
                        @change="$emit('toggle-type', group.value)"
                    />
                    <img
                        v-if="COMPETITION_ICONS[group.value]"
                        :src="COMPETITION_ICONS[group.value]"
                        alt=""
                        class="ui-control-group__competition-icon"
                        aria-hidden="true"
                    />
                    <span>{{ group.label }}</span>
                </label>
                <FilterSelectAllButton
                    :all-selected="isGroupFullySelected(group)"
                    :disabled="disabled"
                    @toggle="$emit('toggle-group', group)"
                />
            </div>
            <div v-if="group.stages.length" class="ui-control-group__stages">
                <label
                    v-for="stage in group.stages"
                    :key="stage.value"
                    class="ui-control-group__stage"
                >
                    <input
                        type="checkbox"
                        :checked="pendingStages.includes(stage.value)"
                        :disabled="disabled"
                        @change="$emit('toggle-stage', stage.value)"
                    />
                    <span
                        class="ui-control-stage-label"
                        :class="{ 'ui-control-stage-label--icon-only': stage.medal }"
                    >
                        <img
                            v-if="stage.medal"
                            :src="`/images/icons/medal-${stage.medal}.svg`"
                            :alt="stage.label"
                            :title="stage.label"
                            class="ui-control-stage-label__medal"
                        />
                        <span v-else>{{ stage.label }}</span>
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script setup>
import FilterSelectAllButton from '@/components/advanced-stats/FilterSelectAllButton.vue';
import { COMPETITION_ICONS } from '@/utils/skillQualityConfig';

const props = defineProps({
    groups: { type: Array, default: () => [] },
    pendingTypes: { type: Array, default: () => [] },
    pendingStages: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    isGroupFullySelected: { type: Function, required: true },
});

defineEmits(['toggle-type', 'toggle-group', 'toggle-stage']);
</script>
